import React from 'react';
import StatusPage from './StatusPage.jsx';

export function Unauthorized401() {
  return (
    <StatusPage
      code="401"
      title="Unauthorized"
      message="You need to sign in to view this page. Please log in and try again."
      icon="fa fa-lock"
      variant="warning"
    />
  );
}

export function Forbidden403() {
  return (
    <StatusPage
      code="403"
      title="Forbidden"
      message="You don't have permission to access this resource."
      icon="fa fa-ban"
      variant="danger"
    />
  );
}

export function NotFound404() {
  return (
    <StatusPage
      code="404"
      title="Page Not Found"
      message="The page you're looking for doesn't exist or hasn't been built yet."
      icon="fa fa-map-signs"
      variant="primary"
    />
  );
}

export function ServerError500() {
  return (
    <StatusPage
      code="500"
      title="Server Error"
      message="Something went wrong on our end. Please try again later."
      icon="fa fa-bug"
      variant="danger"
    />
  );
}
